import React, { ReactElement } from 'react';

interface EmailOpenerProps {
  address: string;
  subject: string;
  body: string;
  children: ReactElement;
}

const EmailOpener: React.FC<EmailOpenerProps> = ({ address, subject, body, children }) => {
  const handleClick = () => {
    const mailto = `mailto:${address}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.open(mailto, '_blank');
  };

  return React.cloneElement(children, { onClick: handleClick });
};

export default EmailOpener;
